import { atomWithLocalStorage } from "../../uilts/state";

export const currentWordIndexAtom = atomWithLocalStorage(
  "currentWordIndexAtom",
  0
);
